class Wait {
  public forNodeList(selector:any, poll:number, attempts:number) {
    return new Promise<NodeList>((resolve, reject) => {
      this.attempt(selector, poll, attempts, 1, resolve, reject, false);
    });
  }

  public forHTMLElement(selector:any, poll:number, attempts:number) {
    return new Promise<HTMLElement>((resolve, reject) => {
      this.attempt(selector, poll, attempts, 1, resolve, reject, true);
    });
  }

  private attempt(selector:string, poll:number, attempts:number, attempt:number, resolve:any, reject:any, isHtmlElement:boolean) {
    if (isHtmlElement) {
      const htmlElement = document.querySelector(selector);
      if (htmlElement) resolve(htmlElement);
    } else {
      const nodeList = document.querySelectorAll(selector);
      if (nodeList.length) resolve(nodeList);
    }
    if (attempt === attempts) resolve([]);
    attempt++;
    setTimeout(() => this.attempt(selector, poll, attempts, attempt, resolve, reject, isHtmlElement), poll);
  }
}

export default new Wait();
